import React, { useEffect, useRef, useState } from "react";
import Calculator from "./Calculator";
import axios from "axios";
import { apiKey } from "../../config/config";
import POSHoldOrder from "./POSHoldOrder";
import { languageHelper } from "../../config/helperFunctions";

function POSLeftHeader({
  sidebarToggle,
  deliveryOrders,
  dineInOrders,
  takeawayOrders,
  holdOrders,
  fetchOrders,
  setSelectedOrder,
  setSelectedOrderType,
  setOrderItemDetail,
  setIsUpdate,
}) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const [showCalc, setShowCalc] = useState(false);
  const [showDineinModal, setShowDineinModal] = useState(false);
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [showTakeawayModal, setShowTakeawayModal] = useState(false);
  const [isHoldModalOpen, setIsHoldModalOpen] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [orderDetail, setOrderDetail] = useState(null);
  // const [holdOrders, setHoldOrders] = useState([]);
  const [dineInData, setDineInData] = useState(dineInOrders);
  const [takeawayData, setTakeawayData] = useState(takeawayOrders);
  const [deliveryData, setDeliveryData] = useState(deliveryOrders);
  const [search, setSearch] = useState("");
  // const [playSound, setPlaySound] = useState(false);
  // const [deliveryData, setDeliveryData] = useState(deliveryOrders);
  // const [takeawayData, setTakeawayData] = useState(takeawayOrders);
  const handleLangChange = (value) => {
    localStorage.setItem("rms-lang", value);
    window.location.reload();
  };
  const handleStatusUpdate = (id, status) => {
    axios
      .post(
        `${apiKey}/api/rms/admin/order/${id}/status`,
        {
          approval_status: status,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        fetchOrders();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const toggleFullScreen = () => {
    const doc = window.document;
    const docEl = doc.documentElement;

    const requestFullScreen =
      docEl.requestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen ||
      docEl.msRequestFullscreen;

    const exitFullScreen =
      doc.exitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.webkitExitFullscreen ||
      doc.msExitFullscreen;

    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      requestFullScreen.call(docEl);
    } else {
      exitFullScreen.call(doc);
    }
  };

  const previousLengths = useRef({
    dineInData: 0,
    takeawayData: 0,
    deliveryData: 0,
  });

  useEffect(() => {
    setDineInData(
      dineInOrders.filter((order) =>
        String(order.sale_no).toLowerCase().includes(search)
      )
    );
    setTakeawayData(
      takeawayOrders.filter(
        (order) =>
          String(order.sale_no).toLowerCase().includes(search) ||
          order.customer?.name.toLowerCase().includes(search) ||
          order.customer?.phone.toLowerCase().includes(search) ||
          (order.is_guest === "yes" &&
            order.guest?.name.toLowerCase().includes(search)) ||
          (order.is_guest === "yes" &&
            String(order.guest?.phone).toLowerCase().includes(search))
      )
    );
    setDeliveryData(
      deliveryOrders.filter(
        (order) =>
          String(order.sale_no).toLowerCase().includes(search) ||
          order.customer?.name.toLowerCase().includes(search) ||
          order.customer?.phone.toLowerCase().includes(search) ||
          (order.is_guest === "yes" &&
            order.guest?.name.toLowerCase().includes(search)) ||
          (order.is_guest === "yes" &&
            String(order.guest?.phone).toLowerCase().includes(search)) ||
          order.address.toLowerCase().includes(search)
      )
    );
  }, [deliveryOrders, dineInOrders, search, takeawayOrders]);

  // const playNotificationSound = () => {
  //   const audio = new Audio("/assets/notification.mp3");
  //   audio.play().catch((err) => {
  //     console.error("Audio playback failed:", err);
  //   });
  // };

  useEffect(() => {
    if (
      dineInData.length > previousLengths.current.dineInData ||
      takeawayData.length > previousLengths.current.takeawayData ||
      deliveryData.length > previousLengths.current.deliveryData
    ) {
      const playAudio = async () => {
        try {
          await audioRef.current.play();
          console.log("Audio is playing");
        } catch (error) {
          console.error("Failed to play audio:", error);
        }
      };

      playAudio();
    }

    // Update the previous lengths
    previousLengths.current = {
      dineInData: dineInData.length,
      takeawayData: takeawayData.length,
      deliveryData: deliveryData.length,
    };
  }, [dineInData, takeawayData, deliveryData]);
  const audioRef = useRef(null);
  // useEffect(() => {
  //     // Page load hone par audio play karne ki koshish
  //     const playAudio = async () => {
  //       try {
  //         await audioRef.current.play();
  //         console.log("Audio is playing");
  //       } catch (error) {
  //         console.error("Failed to play audio:", error);
  //       }
  //     };

  //     playAudio();
  //   }, []);
  return (
    <header className="my-1">
      <div className="py-2 flex flex-wrap justify-start gap-x-0.5 gap-y-1 items-center">
        {/* {playSound && (
          <audio src="/assets/notification.mp3" autoPlay>
            {setPlaySound(false)}
          </audio>
        )} */}
        {/* <audio ref={audioRef} src="/assets/notification.mp3" preload="auto" muted autoPlay /> */}
        <select
          className="bg-white w-28 h-8 border border-d-bg rounded-md"
          name=""
          id=""
          onChange={(e) => handleLangChange(e.target.value)}
          // onClick={playNotificationSound}
        >
          <option selected={defaultLang === "text_en"} value="text_en">English</option>
          <option selected={defaultLang === "text_ar"} value="text_ar">Arabic</option>
        </select>
        <button onClick={toggleFullScreen}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="16"
            viewBox="0 0 512 512"
            className="fill-d-bg-text"
          >
            <path d="M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z" />
          </svg>
        </button>
        <button onClick={() => sidebarToggle()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="16"
            viewBox="0 0 512 512"
            className="fill-d-bg-text"
          >
            <path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z" />
          </svg>
        </button>
        <span className="relative">
          <button onClick={() => setShowCalc(!showCalc)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              width="12"
              viewBox="0 0 384 512"
              className="fill-d-bg-text"
            >
              <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z" />
            </svg>
          </button>
          {showCalc && (
            <span className="absolute top-5 -right-20 z-10">
              <Calculator />
            </span>
          )}
        </span>
        <button onClick={() => setIsHoldModalOpen(true)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="18"
            viewBox="0 0 576 512"
            className="fill-d-bg-text"
          >
            <path d="M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z" />
          </svg>
        </button>
        <button
          onClick={() => setShowDineinModal(true)}
          className="bg-d-cat-btn text-white px-2 py-1 rounded-md text-xs flex gap-0.5"
        >
          <span className="hidden lg:inline">
            {languageHelper(defaultLang, "Dine-in")}
          </span>{" "}
          <img
            src="/assets/icons/dinein.png"
            className="w-4 lg:hidden"
            alt=""
          />{" "}
          ({dineInData.length || 0})
        </button>
        <button
          onClick={() => setShowTakeawayModal(true)}
          className="bg-d-cat-btn text-white px-2 py-1 rounded-md text-xs flex gap-0.5"
        >
          <span className="hidden lg:inline">
            {languageHelper(defaultLang, "Pick-Up")}
          </span>{" "}
          <img
            src="/assets/icons/takeaway.png"
            className="w-4 lg:hidden"
            alt=""
          />{" "}
          ({takeawayOrders.length || 0})
        </button>
        <button
          onClick={() => setShowDeliveryModal(true)}
          className="bg-d-cat-btn text-white px-2 py-1 rounded-md text-xs flex gap-0.5"
        >
          <span className="hidden lg:inline">
            {languageHelper(defaultLang, "Delivery")}
          </span>{" "}
          <img
            src="/assets/icons/delivery.png"
            className="w-4 lg:hidden"
            alt=""
          />{" "}
          ({deliveryOrders.length || 0})
        </button>
        {/* <button className="bg-d-cat-btn text-white px-2 py-1 rounded-md text-xs">
          Pending Payments(0)
        </button> */}
      </div>
      {isHoldModalOpen && (
        <>
          <div
            onClick={() => setIsHoldModalOpen(false)}
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black bg-opacity-50"
          >
            <div
              className="max-w-4xl w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <POSHoldOrder
                fetchOrders={fetchOrders}
                setIsHoldModalOpen={setIsHoldModalOpen}
                holdOrders={holdOrders}
                setSelectedOrder={setSelectedOrder}
                setSelectedOrderType={setSelectedOrderType}
                setOrderItemDetail={setOrderItemDetail}
                setIsUpdate={setIsUpdate}
              />
            </div>
          </div>
        </>
      )}
      {showDineinModal && (
        <>
          <div
            onClick={() => setShowDineinModal(false)}
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black bg-opacity-50"
          >
            <div
              className="relative mx-auto w-7/12 h-4/5"
              onClick={(e) => e.stopPropagation()}
            >
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel ">
                {/*header*/}
                <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
                  <h1 className="text-xl text-d-bg-text">
                    {languageHelper(defaultLang, "Dine-in Orders")}
                  </h1>
                  <button
                    className="ml-auto float-right text-2xl"
                    onClick={() => setShowDineinModal(false)}
                  >
                    <span className="text-d-bg-text"> × </span>
                  </button>
                </div>
                <div className="p-2">
                  <input
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    className="border mb-4 px-1"
                    placeholder={languageHelper(defaultLang, "Search")}
                  />
                  <table className="w-full">
                    <thead className="bg-d-bg text-white font-bold">
                      <tr>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Order Number")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Table")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Actions")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dineInData.map((data, index) => (
                        <tr
                          key={index}
                          className={`${
                            index % 2 === 0 && "bg-gray-100"
                          } hover:bg-gray-100`}
                        >
                          <td className="border px-2 py-4">{data.sale_no}</td>
                          <td className="border px-2 py-4">{data.table?.name}</td>
                          <td className="flex gap-2 border px-2 py-4">
                            <button
                              onClick={() => {
                                setOrderDetail(data);
                                setShowViewModal(true);
                              }}
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-blue-500"
                            >
                              {languageHelper(defaultLang, "View")}
                            </button>
                            <button
                              onClick={() =>
                                handleStatusUpdate(data.id, "approved")
                              }
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-green-500"
                            >
                              {languageHelper(defaultLang, "Approve")}
                            </button>
                            <button
                              onClick={() =>
                                handleStatusUpdate(data.id, "declined")
                              }
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-red-500"
                            >
                              {languageHelper(defaultLang, "Decline")}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showDeliveryModal && (
        <>
          <div
            onClick={() => setShowDeliveryModal(false)}
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black bg-opacity-50"
          >
            <div
              className="relative mx-auto w-7/12 h-4/5"
              onClick={(e) => e.stopPropagation()}
            >
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel ">
                {/*header*/}
                <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
                  <h1 className="text-xl text-d-bg-text">
                    {languageHelper(defaultLang, "Delivery Orders")}
                  </h1>
                  <button
                    className="ml-auto float-right text-2xl"
                    onClick={() => setShowDeliveryModal(false)}
                  >
                    <span className="text-d-bg-text"> × </span>
                  </button>
                </div>
                <div className="p-2">
                  <input
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    className="border mb-4 px-1"
                    placeholder="Search"
                  />
                  <table className="w-full">
                    <thead className="bg-d-bg text-white font-bold">
                      <tr>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Order Number")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Name")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Phone")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Address")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Action")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {deliveryData.map((data, index) => (
                        <tr
                          key={index}
                          className={`${
                            index % 2 === 0 && "bg-gray-100"
                          } hover:bg-gray-100`}
                        >
                          <td className="border px-2 py-4">{data.sale_no}</td>
                          <td className="border px-2 py-4">
                            {data.is_guest === "yes"
                              ? data.guest?.name
                              : data.customer?.name}
                          </td>
                          <td className="border px-2 py-4">
                            {data.is_guest === "yes"
                              ? data.guest?.phone
                              : data.customer?.phone}
                          </td>
                          <td className="border px-2 py-4">{data.address}</td>
                          <td className="flex gap-2 border px-2 py-4">
                            <button
                              onClick={() => {
                                setOrderDetail(data);
                                setShowViewModal(true);
                              }}
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-blue-500"
                            >
                              {languageHelper(defaultLang, "View")}
                            </button>
                            <button
                              onClick={() =>
                                handleStatusUpdate(data.id, "approved")
                              }
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-green-500"
                            >
                              {languageHelper(defaultLang, "Approve")}
                            </button>
                            <button
                              onClick={() =>
                                handleStatusUpdate(data.id, "declined")
                              }
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-red-500"
                            >
                              {languageHelper(defaultLang, "Decline")}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showTakeawayModal && (
        <>
          <div
            onClick={() => setShowTakeawayModal(false)}
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black bg-opacity-50"
          >
            <div
              className="relative mx-auto w-7/12 h-4/5"
              onClick={(e) => e.stopPropagation()}
            >
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel ">
                {/*header*/}
                <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
                  <h1 className="text-xl text-d-bg-text">
                    {languageHelper(defaultLang, "Takeaway Orders")}
                  </h1>
                  <button
                    className="ml-auto float-right text-2xl"
                    onClick={() => setShowTakeawayModal(false)}
                  >
                    <span className="text-d-bg-text"> × </span>
                  </button>
                </div>
                <div className="p-2">
                  <input
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    className="border mb-4 px-1"
                    placeholder="Search"
                  />
                  <table className="w-full">
                    <thead className="bg-d-bg text-white font-bold">
                      <tr>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Name")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Pickup Time")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Phone")}
                        </th>
                        <th className="text-start px-2">
                          {languageHelper(defaultLang, "Actions")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {takeawayData.map((data, index) => (
                        <tr
                          key={index}
                          className={`${
                            index % 2 === 0 && "bg-gray-100"
                          } hover:bg-gray-100`}
                        >
                          <td className="border px-2 py-4">
                            {data.is_guest === "yes"
                              ? data.guest?.name
                              : data.customer?.name}
                          </td>
                          <td className="border px-2 py-4">
                            {data.takeaway_time}
                          </td>
                          <td className="border px-2 py-4">
                            {data.is_guest === "yes"
                              ? data.guest?.phone
                              : data.customer?.phone}
                          </td>
                          <td className="flex gap-2 border px-2 py-4">
                            <button
                              onClick={() => {
                                setOrderDetail(data);
                                setShowViewModal(true);
                              }}
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-blue-500"
                            >
                              {languageHelper(defaultLang, "View")}
                            </button>
                            <button
                              onClick={() =>
                                handleStatusUpdate(data.id, "approved")
                              }
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-green-500"
                            >
                              {languageHelper(defaultLang, "Approve")}
                            </button>
                            <button
                              onClick={() =>
                                handleStatusUpdate(data.id, "declined")
                              }
                              className="text-white rounded px-2 py-1 text-xs font-medium bg-red-500"
                            >
                              {languageHelper(defaultLang, "Decline")}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showViewModal && (
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black bg-opacity-50">
          <div
            className="relative mx-auto max-w-lg w-full bg-white"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowViewModal(false)}
              className="absolute top-0.5 right-2 text-white font-bold"
            >
              X
            </button>
            <table className="w-full">
              <thead className="bg-d-bg text-white">
                <tr>
                  <th className="text-start px-1">
                    {languageHelper(defaultLang, "Item")}
                  </th>
                  <th className="text-start px-1">
                    {languageHelper(defaultLang, "Price")}
                  </th>
                  <th className="text-start px-1">
                    {languageHelper(defaultLang, "Quantity")}
                  </th>
                  <th className="text-start px-1">
                    {languageHelper(defaultLang, "Total")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {orderDetail.order_details.map((detail, index) => (
                  <tr className="hover:bg-gray-100" key={index}>
                    <td className="py-2 px-1 border">
                      {detail.food_menu.name}
                    </td>
                    <td className="py-2 px-1 border">
                      {detail.menu_price_with_discount}
                    </td>
                    <td className="py-2 px-1 border">{detail.qty}</td>
                    <td className="py-2 px-1 border">
                      {detail.qty * detail.menu_price_with_discount}
                    </td>
                  </tr>
                ))}
                <tr className="hover:bg-gray-100">
                  <td></td>
                  <td></td>
                  <td className="py-2 px-1 border">
                    {languageHelper(defaultLang, "Total")}
                  </td>
                  <td className="py-2 px-1 border">
                    {orderDetail.total_payable}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </header>
  );
}

export default POSLeftHeader;
